<template>
  <Form ref="form" @submit="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">Editar Cliente</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row card-body">
        <!-- Información de solo lectura
        <div class="form-group col-sm-12">
          <label for="ProspectFullname">Prospecto:</label>
          <Field :value="prospectFullname" type="text" class="form-control col-sm-9" name="ProspectFullname" disabled />
        </div> -->

        <div class="form-group col-sm-6">
          <label for="referenceNumber">Folio cliente:</label>
          <Field v-model="client.referenceNumber" type="text" class="form-control col-sm-9" name="referebceNumber"
            disabled />
        </div>

        <div class="form-group col-sm-6">
          <label for="referenceNumberDisposicion">Folio disposición:</label>
          <Field v-model="client.creditFacility.referenceNumber" type="text" class="form-control col-sm-9"
            name="referenceNumberDisposicion" disabled />
        </div>

        <div class="form-group col-sm-6">
          <label for="referenceNumberProspectus">Folio prospecto:</label>
          <Field v-model="client.creditFacility.prospectus.referenceNumber" type="text" class="form-control col-sm-9"
            name="referenceNumberProspectus" disabled />
        </div>

        <div class="form-group col-sm-6">
          <label for="prospectFullname">Prospecto:</label>
          <Field :value="prospectFullname" type="text" class="form-control col-sm-9" name="ProspectFullname" disabled />
        </div>


        <div class="form-group col-sm-12">
          <label for="branchOffice">Nombre de Matriz y/o Sucursal:</label>
          <Field :value="client.creditFacility.prospectus.branchOffice.name" type="text" class="form-control col-sm-9"
            name="BranchOffice" disabled />
        </div>

        <div class="form-group col-sm-6">
          <label for="referenceNumberLoanApplication">Folio solicitud:</label>
          <Field v-model="client.creditFacility.loanApplication.referenceNumber" type="text"
            class="form-control col-sm-9" name="referenceNumberLoanApplication" disabled />
        </div>

        <div class="form-group col-sm-6">
          <label for="referenceNumberScore">Folio credit score:</label>
          <Field v-model="client.creditFacility.creditScore.referenceNumber" type="text" class="form-control col-sm-9"
            name="referenceNumberScore" disabled />
        </div>

        <div class="form-group col-sm-6">
          <label for="score">Score:</label>
          <Field v-model="client.creditFacility.creditScore.score" type="text" class="form-control col-sm-9"
            name="score" disabled />
        </div>

        <!-- Estatus (editable) -->
        <div class="form-group col-sm-5">
          <label for="statusId">Estatus:</label>
          <StatusSelect v-model="client.statusId" :name="'statusId'" :options="statusOptions">
          </StatusSelect>
        </div>


      </div>
    </div>
    <div class="modal-footer justify-content-between">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">
        {{ cancelButton }}
      </button>
      <PrimaryButton class="btn btn-primary" type="submit">
        {{ updateButton }}
      </PrimaryButton>
    </div>
  </Form>
</template>

<script>
import * as helper from '@/helpers';
import { mapState, mapActions } from "pinia";
import { useStatusStore } from '@/pinia/status.module';
import PrimaryButton from "@/Components/PrimaryButton.vue";
import StatusSelect from "@/Components/Selects/SelectField.vue";
import Client from '@/Models/Client';
import { useClientsStore } from '@/pinia/clients.module';

export default {
  components: {
    PrimaryButton,
    StatusSelect
  },
  data() {
  },
  props: {
    client: {
      type: Client,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(useStatusStore, ['getAllStatusByType', 'getSelectedStatus']),
    cancelButton() {
      return this.$getLocaleMessage('buttons', 'cancel');
    },
    updateButton() {
      return this.$getLocaleMessage('buttons', 'update');
    },
    statusOptions() {
      return helper.mapOptions(this.getAllStatusByType(1));
    },
    prospectFullname() {
      if (this.client.creditFacility.prospectus?.generalInformation?.businessName) {
        return this.client.creditFacility.prospectus.generalInformation.businessName;
      } else {
        const info = this.client.creditFacility.prospectus?.generalInformation || {};
        return `${info.firstName || ''} ${info.lastName || ''} ${info.mothersMaidenName || ''}`.trim();
      }
    }
  },
  methods: {
    ...mapActions(useClientsStore, ['changeStatusClient']),
    async onSubmit() {
      this.changeStatusClient(this.client);
      this.closeModal();
    },
    closeModal() {
      this.$emit('closeModal', true);
    }
  }
}

</script>